import { IExportColumn } from '../interfaces';

/**
 * Resolves a cell value from row data using key/transform rules.
 */
export function resolveExportCellValue<TRow>(row: TRow, column: IExportColumn<TRow>): unknown {
  const key = column.key as string;
  const sourceRow = row as Record<string, unknown>;
  const rawValue = sourceRow[key];

  if (column.transform == null) {
    return rawValue;
  }

  return column.transform(rawValue, row);
}

/**
 * Normalizes any value to a primitive export-safe value.
 */
export function normalizeExportValue(value: unknown): string | number | boolean {
  if (value == null) {
    return '';
  }

  if (value instanceof Date) {
    return value.toISOString();
  }

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }

  return String(value);
}

/**
 * Ensures a file name ends with the target extension.
 */
export function ensureFileExtension(fileName: string, extension: string): string {
  const normalizedExtension = extension.startsWith('.') ? extension : `.${extension}`;

  if (fileName.toLowerCase().endsWith(normalizedExtension.toLowerCase())) {
    return fileName;
  }

  return `${fileName}${normalizedExtension}`;
}
